import type { ROUTES } from '@ui/constants/routes';
import { getSubRouteParent } from '@ui/constants/routes';
import type { Router } from '@ui/lib/i18n';

/**
 * Determines if a given pathname is a sub-route of a specified route.
 *
 * @param {ROUTES} route - The route to compare against.
 * @param {string} pathname - The pathname to check.
 * @example isSubRoute('/[locale]/dashboard-earn', '/dashboard') => true
 */
export const isSubRouteWithLocale = (
  route: ROUTES,
  pathname: Router['pathname'],
) => {
  const pathnameWithoutLocale = pathname.replace('/[locale]', '');

  return (
    route === pathnameWithoutLocale ||
    route === getSubRouteParent(pathnameWithoutLocale)
  );
};
